import { render, staticRenderFns } from "./LayoutPicker.vue?vue&type=template&id=34646b67&scoped=true&"
import script from "./LayoutPicker.vue?vue&type=script&lang=js&"
export * from "./LayoutPicker.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPicker.vue?vue&type=style&index=0&id=34646b67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34646b67",
  null
  
)

export default component.exports